export const BET_TYPES = {
  PLAYER: 0,
  BANKER: 1,
  TIE: 2,
  PLAYER_PAIR: 3,
  BANKER_PAIR: 4,
};

export const BET_TYPES_VIEW = {
  PLAYER_PAIR: 0,
  PLAYER: 1,
  TIE: 2,
  BANKER: 3,
  BANKER_PAIR: 4,
};

export const ODD_BY_BET_TYPE = {
  0: '1:1',
  1: '0.95:1',
  2: '8:1',
  3: '11:1',
  4: '11:1',
};

export const ROUND_WIN_TYPE = {
  0: 'BANKER',
  1: 'PLAYER',
  2: 'TIE',
};

export const ROUND_WIN_TYPE_VIEW = {
  0: 'BANKER',
  1: 'PLAYER',
  2: 'TIE',
  3: 'PLAYER_PAIR',
  4: 'BANKER_PAIR',
};

export const BET_HISTORY_WIN_TYPE_VIEW = {
  0: 'PLAYER',
  1: 'BANKER',
  2: 'TIE',
  3: 'PLAYER_PAIR',
  4: 'BANKER_PAIR',
};

export const ROUND_BET_TYPE_VIEW = {
  BANKER: 0,
  PLAYER: 1,
  TIE: 2,
  PLAYER_PAIR: 3,
  BANKER_PAIR: 4,
};

export const ROUND_WIN_TYPE_COLOR = {
  0: 'banker',
  1: 'player',
  2: 'tie',
};

export const COLOR_BY_WIN_TYPE = {
  BANKER: 'red',
  PLAYER: 'blue',
  TIE: 'green',
};

export const WIN_TYPE_NAME = {
  0: 'B',
  1: 'P',
  2: 'T',
};
